import React from "react";
import StepContentForm from "./StepContentForm/StepContentForm";

const GetStepContentComponent = ({
	numberStep,
	setMarca,
	marca,
	setValidation,
	setTitulo,
	titulo,
	setTipo,
	tipo,
	setNum,
	num,
	setImg,
	img,
	setPrecio,
	precio,
	setError,
	validation,
	error,
	type,
	disableInput,
	setDisableInput,
}) => {
	function getStepContent(step) {
		switch (step) {
			case 0:
				return (
					<StepContentForm
						textLabel={
							type === "add" ? "Añadir marca(s)" : "Actualizar marca(s)"
						}
						inputType="text"
						inputName="Modelo"
						setInputField={setMarca}
						inputFields={marca}
						placeholder={type === "add" && "Apple"}
						setValidate={setValidation}
						setError={setError}
						infoText={
							<>
								* Si la pieza es compatible con un modelo de otra marca añádela
								haciendo click en <b>Agregar marca compatible</b>
							</>
						}
						type={type}
						spanClassName="addOrEditForm__validation"
						spanError={!validation && error}
						dynamicInputs={true}
						addDynamicInput="Agregar marca compatible"
					/>
				);
			case 1:
				return (
					<StepContentForm
						textLabel={
							type === "add"
								? 'Añadir modelos(s)'
								: "Actualizar modelo(s)"
						}
						inputType="text"
						inputName="Modelo"
						setInputField={setTitulo}
						inputFields={titulo}
						placeholder={type === "add" && "iPhone X / iPhone XS / iPhone XS Max"}
						setValidate={setValidation}
						setError={setError}
						infoText={
							<>
								* Si agregaste alguna marca compatible añade los modelos que
								correspondan a la marca haciendo click en{" "}
								<b>Agregar modelo compatible</b>
								<br />
								Separa los modelos de cada marca con una diagonal ("/")
							</>
						}
						type={type}
						spanClassName="addOrEditForm__validation"
						spanError={!validation && error}
						dynamicInputs={true}
						addDynamicInput="Agregar modelo compatible"
					/>
				);
			case 2:
				return (
					<StepContentForm
						textLabel={
							type === "add"
								? "Añadir tipo de refacción"
								: "Actualizar tipo de refacción"
						}
						inputType="text"
						inputName="Tipo"
						placeholder={type === "add" && "Cristal de cámara"}
						setInputField={setTipo}
						inputField={tipo}
						infoText={
							<>
								* Inserta el nombre correspondiente del tipo de flexor o
								micro-componente de la refacción
							</>
						}
						type={type}
						setValidate={setValidation}
						setError={setError}
						spanClassName="addOrEditForm__validation"
						spanError={!validation && error}
					/>
				);
			case 3:
				return (
					<StepContentForm
						textLabel={
							type === "add"
								? "Añadir la numeración de modelos"
								: "Actualizar la numeración de los modelos"
						}
						inputType="text"
						inputName="Numeracion"
						setInputField={setNum}
						placeholder={type === "add" && "A1865 A1901 A1902 A1920 A2097 A2098 A2099 A2100 A1921 A2101 A2102 A2103 A2104"}
						inputFields={num}
						infoText={
							<>
								* Si agregaste alguna marca compatible añade la numeración de
								los modelos que correspondan a la marca haciendo click en
								<b> Agregar numeración para modelo compatible</b>
								<br />
								Separa la numeración de los modelos de cada marca con una diagonal ("/")
							</>
						}
						type={type}
						setValidate={setValidation}
						setError={setError}
						spanClassName="addOrEditForm__validation"
						spanError={!validation && error}
						dynamicInputs={true}
						addDynamicInput="Agregar numeración para modelo compatible"
						checkToDisableInput={true}
						textToDisableInput="No tiene numeración"
						setDisableInput={setDisableInput}
						disableInput={disableInput}
					/>
				);
			case 4:
				return (
					<StepContentForm
						textLabel={
							type === "add"
								? "Añadir links de las imagenes"
								: "Actualizar links de las imagenes"
						}
						inputType="text"
						inputName="Imagenes"
						setInputField={setImg}
						placeholder={type === "add" && "https://i.ibb.co/SmjwC7H/cristal-camara-iphone-x.png"}
						inputFields={img}
						type={type}
						infoText={
							<>
								* Inserta la URL de de la imagen que has subido anteriormente a
								la plataforma de imgbb o a algún otro servidor para imagenes
								Si hay más de una imagen agrégalas haciendo click en <b>Agregar link</b>
							</>
						}
						setValidate={setValidation}
						setError={setError}
						spanClassName="addOrEditForm__validation"
						spanError={!validation && error}
						dynamicInputs={true}
						addDynamicInput="Agregar link"
					/>
				);
			case 5:
				return (
					<StepContentForm
						textLabel={
							type === "add"
								? "Añadir costo de la refacción"
								: "Actualizar costa de la refacción"
						}
						inputType="number"
						inputName="Precio"
						placeholder={type === "add" && "80"}
						setInputField={setPrecio}
						inputField={precio}
						type={type}
						infoText={
							<>
								* Inserta el precio de mayoreo del producto
							</>
						}
						setValidate={setValidation}
						setError={setError}
						classNameInput="inputPrice"
						spanClassName="addOrEditForm__validation"
						spanError={!validation && error}
					/>
				);
			default:
				return "No se ha podido cargar ningun paso";
		}
	}
	return <>{getStepContent(numberStep)}</>;
};

export default GetStepContentComponent;
